import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import { useState } from 'react';
import { ButtonFooter } from '~/components';
import { b2bSideCopy } from '../../b2bSideCopy';
import { useMsaasListingSearchRef } from '../../marketSelectors';
import { useSearchSide } from '../searchSide';
import { AssociatedProviderPicker } from './AssociatedProviderPicker';

export const ApplyModal = () => {
  const { msaasListingsSearchRef } = useMsaasListingSearchRef();
  if (!msaasListingsSearchRef) return null;

  return <ApplyModalContent msaasListingsSearchRef={msaasListingsSearchRef} />;
};

type MsaasListingsSearchRef = NonNullable<
  ReturnType<typeof useMsaasListingSearchRef>['msaasListingsSearchRef']
>;

const ApplyModalContent = ({
  msaasListingsSearchRef,
}: {
  msaasListingsSearchRef: MsaasListingsSearchRef;
}) => {
  const side = useSearchSide();
  const copy = b2bSideCopy(side);
  const employerId = useSelector(
    msaasListingsSearchRef,
    (s) => s?.context.employerUser?.employerId
  );
  const [providerIds, setProviderIds] = useState<number[]>([]);
  const handleApply = () => {
    msaasListingsSearchRef.send({
      type: 'ON_CONFIRM_APPLY',
      payload: { providerIds },
    });
  };
  return (
    <>
      <div>{copy.applyIntro}</div>
      {side === 'SEEKING' && (
        <AssociatedProviderPicker
          employerId={employerId}
          selectedProviderIds={providerIds}
          onChange={setProviderIds}
        />
      )}
      <ButtonFooter
        primaryButton={{
          label: copy.requestLaborCta,
          cyTag: CT.listingSearch.detailPanel.applyConfirmBtn,
          isSubmit: false,
          onClick: handleApply,
        }}
      />
    </>
  );
};
